import React, { useEffect, useState } from "react";
import { signInWithEmailAndPassword, onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "../firebase";
import { useNavigate } from "react-router-dom";
import Loader from "./Loader";

function EmpLogin() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [checkingSession, setCheckingSession] = useState(true);

  /* ✅ AUTO REDIRECT IF ALREADY LOGGED IN */
  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setCheckingSession(false);
        return;
      }

      try {
        const snap = await getDoc(doc(db, "users", user.uid));
        if (!snap.exists()) {
          setCheckingSession(false);
          return;
        }

        const { role } = snap.data();

        if (role === "admin") {
          navigate("/AdminDashboard", { replace: true });
        } else if (role === "employee") {
          navigate("/components/EmployeeAttendance", { replace: true });
        }
      } catch (err) {
        console.error(err);
      }
    });

    return () => unsub();
  }, [navigate]);

  /* ✅ LOGIN HANDLER */
  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const cred = await signInWithEmailAndPassword(auth, email, password);
      const uid = cred.user.uid;

      const snap = await getDoc(doc(db, "users", uid));
      if (!snap.exists()) {
        setError("User profile not found");
        return;
      }

      const { role } = snap.data();

      if (role === "admin") {
        navigate("/AdminDashboard", { replace: true });
      } else if (role === "employee") {
        navigate("/components/EmployeeAttendance", { replace: true });
      } else {
        setError("Invalid role assigned");
      }
    } catch (err) {
      console.error(err);
      setError("Invalid email or password");
    }
  };

  /* ✅ SESSION CHECK LOADER */
  if (checkingSession) {
    return <Loader />;
  }

  return (
    <div className="container mt-5" style={{ maxWidth: 400 }}>
      <h3 className="text-center">Login</h3>

      {error && <div className="alert alert-danger">{error}</div>}

      <form onSubmit={handleLogin}>
        <input
          className="form-control mb-2"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <input
          type="password"
          className="form-control mb-2"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        {/* Remember me is already handled globally by Firebase persistence */}
        <div className="form-check mb-3">
          <input className="form-check-input" type="checkbox" checked readOnly />
          <label className="form-check-label">Remember me</label>
        </div>

        <button className="btn btn-primary w-100">Login</button>
      </form>
    </div>
  );
}

export default EmpLogin;
